/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    span: "span",
    p: "p",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "abstract"
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#abstract"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), "Abstract"), "\n", React.createElement(_components.p, null, "The unique aquatic nature of swimming makes it very difficult to use social or technical strategies to mitigate the tediousness of monotonous exercises. In this study, we propose MobyDick, a smartphone-based multi-player exergame designed to be used while swimming, in which a team of swimmers collaborate to hunt down a virtual monster. In this paper, we present a novel, holistic game design that takes into account both human factors and technical challenges. Firstly, we perform a comparative analysis of a variety of wireless networking technologies in the aquatic environment and identify various technical constraints on wireless networking. Secondly, we develop a single phone-based inertial and barometric stroke activity recognition system to enable precise, real-time game inputs. Thirdly, we carefully devise a multi-player interaction mode viable in the underwater environment highly limiting the abilities of human communication. Finally, we prototype MobyDick on waterproof off-the-shelf Android phones, and deploy it to real swimming pool environments (n = 8). Our qualitative analysis of user interview data reveals certain unique aspects of multi-player swimming games."), "\n", React.createElement("iframe", {
    className: "w-full aspect-video",
    src: "https://www.youtube.com/embed/DQ_yqnNBudg?si=a7-MqL7zLcF3HJ_c",
    title: "MobyDick: An Interactive Multi-swimmer Exergame",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  }), "\n", React.createElement(_components.h1, {
    id: "links"
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#links"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), "Links"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://drive.google.com/uc?export=download&id=12tJN8z1PALZ0fpOJMtougSKyrsIYO1PK",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Paper")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://drive.google.com/uc?export=download&id=1Xr6tUmSWtzI_AmkDLCk7zj9cn2o83hQW",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Slide")), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
